 <template>
  <div class="form-group">
    <TinyMCE
      style="padding: 0.5em; border: 1px solid; border-color: #d8dbe0; border-radius: 0.25rem;"
      :value="tmpValue"
      @input="onValueChange"
    />
  </div>
</template>

<script>
import TinyMCE from '../TinyMCE.vue'

export default {
  name: "HtmlTextBox",
  components: {
    TinyMCE,
  },
  props: {
    value: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
    };
  },
  computed: {
    tmpValue() {
      return this.value
    }
  },
  methods: {
    onValueChange(newVal) {
      this.$emit('input', newVal)
    },
  },
  mounted() {},
  watch: {
  }
};
</script>

<style>
</style>